import type { EmbarcacaoDetailSectionProps } from "../../embarcacao-detail-section";
import { useThrustersSection } from "./use-thrusters-section";
import { ThrustersSectionView } from "./view-thrusters-section";

export function ThrustersSection(props: EmbarcacaoDetailSectionProps) {
  const vm = useThrustersSection(props);

  return <ThrustersSectionView {...vm} />;
}

export type * from "./types-thrusters-section";
